import React from 'react';

import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { SettingDisplayPassword } from 'components/settings/SettingDisplayPassword';
import { SettingDisplayText } from 'components/settings/SettingDisplayText';

export const PaytronixSettingsDisplay: React.FC<IPointOfSaleSettingsProps> = ({ settings, locationId }) => (
    <>
        {/* Common Only */}
        {locationId === undefined && (
            <>
                <SettingDisplayText title="Host" text={settings?.paytronix?.host} />
                <SettingDisplayText title="Username" text={settings?.paytronix?.username} />
                <SettingDisplayPassword title="Password" text={settings?.paytronix?.password} />
                <SettingDisplayText title="Merchant ID" text={settings?.paytronix?.merchantId} />
                <SettingDisplayText title="Card Template Code" text={settings?.paytronix?.cardTemplateCode} />
                <SettingDisplayText title="Store Code" text={settings?.paytronix?.storeCode} />
            </>
        )}
    </>
);
